/* Options:
Date: 2026-03-20 08:25:20
Version: 8.10
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:5001

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: 
*/

//@ts-nocheck

export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IHasSessionId
{
    sessionId: string;
}

export interface IHasBearerToken
{
    bearerToken: string;
}

export interface IPost
{
}

export interface IGet
{
}

export enum TileInformationDataType
{
    List = 1,
    Error = 2,
}

export enum TileInformationDataListItemStatType
{
    Text = 1,
    Chip = 2,
}

// @DataContract
export class TileInformationDataListItemStat
{
    // @DataMember(Order=1)
    public type: TileInformationDataListItemStatType;

    // @DataMember(Order=2)
    public value: string;

    // @DataMember(Order=3)
    public sxStyles: string;

    public constructor(init?: Partial<TileInformationDataListItemStat>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TileInformationDataListItem
{
    // @DataMember(Order=1)
    public iconPrefix: string;

    // @DataMember(Order=2)
    public iconName: string;

    // @DataMember(Order=3)
    public iconColorLight: string;

    // @DataMember(Order=4)
    public iconColorDark: string;

    // @DataMember(Order=5)
    public title: string;

    // @DataMember(Order=6)
    public titleColorLight: string;

    // @DataMember(Order=7)
    public titleColorDark: string;

    // @DataMember(Order=8)
    public subtitle: string;

    // @DataMember(Order=9)
    public subtitleColorLight: string;

    // @DataMember(Order=10)
    public subtitleColorDark: string;

    // @DataMember(Order=11)
    public stats: TileInformationDataListItemStat[];

    public constructor(init?: Partial<TileInformationDataListItem>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TileInformationDataList implements ITileInformationData
{
    // @DataMember(Order=1)
    public type: TileInformationDataType;

    // @DataMember(Order=2)
    public items: TileInformationDataListItem[];

    public constructor(init?: Partial<TileInformationDataList>) { (Object as any).assign(this, init); }
}

export class SentrySettings
{
    public dsn: string;
    public environment: string;
    public customer: string;
    public sendDefaultPii?: boolean;
    public enableMetrics?: boolean;
    public attachStacktrace?: boolean;
    public debug?: boolean;
    public enableLogs?: boolean;
    public enableReportABug?: boolean;
    public replaysOnErrorSampleRate?: number;
    public replaysSessionSampleRate?: number;
    public tracesSampleRate?: number;

    public constructor(init?: Partial<SentrySettings>) { (Object as any).assign(this, init); }
}

export class ClientAppSettings
{
    public sentry: SentrySettings;

    public constructor(init?: Partial<ClientAppSettings>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FavouriteExpandItemState
{
    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public favouriteId?: number;

    // @DataMember(Order=3)
    public expandStateMenuItemId?: number;

    // @DataMember(Order=4)
    public open?: boolean;

    public constructor(init?: Partial<FavouriteExpandItemState>) { (Object as any).assign(this, init); }
}

export class FavouriteWithState
{
    public id?: number;
    public trialId?: number;
    public username: string;
    public favouriteExpandItemStates: FavouriteExpandItemState[];

    public constructor(init?: Partial<FavouriteWithState>) { (Object as any).assign(this, init); }
}

export class Institution
{
    public id?: number;
    public code: string;
    public name: string;

    public constructor(init?: Partial<Institution>) { (Object as any).assign(this, init); }
}

export class TrialLogo
{
    public light: string;
    public dark: string;
    public desktopHeight: string;
    public desktopWidth: string;
    public mobileHeight: string;
    public mobileWidth: string;

    public constructor(init?: Partial<TrialLogo>) { (Object as any).assign(this, init); }
}

export class Trial
{
    public id?: number;
    public name: string;
    public protocolId: string;
    public logo: TrialLogo;

    public constructor(init?: Partial<Trial>) { (Object as any).assign(this, init); }
}

export class SidebarItem
{
    public id?: number;
    public iconPrefix: string;
    public iconName: string;
    public color: string;
    public name: string;
    public link: string;
    public linkNewTab?: boolean;

    public constructor(init?: Partial<SidebarItem>) { (Object as any).assign(this, init); }
}

export class HeaderMenuItem
{
    public id?: number;
    public iconPrefix: string;
    public iconName: string;
    public color: string;
    public name: string;
    public link: string;
    public linkNewTab?: boolean;

    public constructor(init?: Partial<HeaderMenuItem>) { (Object as any).assign(this, init); }
}

export class InformationItem
{
    public iconPrefix: string;
    public iconName: string;
    public name: string;
    public data: string;
    public apiLink: string;
    public dataKey: string;
    public expandStateMenuItemId?: number;

    public constructor(init?: Partial<InformationItem>) { (Object as any).assign(this, init); }
}

export class TileConditions
{
    public operator: string;
    public value: string;

    public constructor(init?: Partial<TileConditions>) { (Object as any).assign(this, init); }
}

export class TileDataColoursAndConditions
{
    public darkColour: string;
    public lightColour: string;
    public conditions: TileConditions[];

    public constructor(init?: Partial<TileDataColoursAndConditions>) { (Object as any).assign(this, init); }
}

export class TooltipInformation
{
    public heading: string;
    public content: string;

    public constructor(init?: Partial<TooltipInformation>) { (Object as any).assign(this, init); }
}

export class TileMenuItem
{
    public iconPrefix: string;
    public iconName: string;
    public name: string;
    public link: string;
    public linkNewTab?: boolean;
    public data: string;
    public apiLink: string;
    public dataKey: string;
    public expandable?: boolean;
    public expandStateMenuItemId?: number;
    public dataColoursAndConditions: TileDataColoursAndConditions[];
    public tooltipInformations: TooltipInformation[];
    public subTileMenuItems: TileMenuItem[];

    public constructor(init?: Partial<TileMenuItem>) { (Object as any).assign(this, init); }
}

export class TileInstitutionData
{
    public institutionId?: number;
    public institutionName: string;
    public informationItems: InformationItem[];
    public tileMenuItems: TileMenuItem[];

    public constructor(init?: Partial<TileInstitutionData>) { (Object as any).assign(this, init); }
}

export interface ITileInformationData
{
    type: TileInformationDataType;
}

// @DataContract
export class UserApiKey
{
    // @DataMember(Order=1)
    public key: string;

    // @DataMember(Order=2)
    public keyType: string;

    // @DataMember(Order=3)
    public expiryDate?: string;

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<UserApiKey>) { (Object as any).assign(this, init); }
}

export class GetClientAppSettingsResponse
{
    public settings: ClientAppSettings;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetClientAppSettingsResponse>) { (Object as any).assign(this, init); }
}

export class GetFavouritesResponse
{
    public favourites: FavouriteWithState[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetFavouritesResponse>) { (Object as any).assign(this, init); }
}

export class SetFavouriteResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SetFavouriteResponse>) { (Object as any).assign(this, init); }
}

export class SetItemStatesResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SetItemStatesResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionsByUserResponse
{
    public instituions: Institution[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetInstitutionsByUserResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialsByUserAndInstitutionIdResponse
{
    public trials: Trial[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetTrialsByUserAndInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetSidebarByUserResponse
{
    public sidebar: SidebarItem[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetSidebarByUserResponse>) { (Object as any).assign(this, init); }
}

export class GetHeaderMenuByUserResponse
{
    public headerMenu: HeaderMenuItem[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetHeaderMenuByUserResponse>) { (Object as any).assign(this, init); }
}

export class GetTrialsMenuItemsResponse
{
    public tileInstitutionData: TileInstitutionData;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetTrialsMenuItemsResponse>) { (Object as any).assign(this, init); }
}

export class GetITileDataByInstitutionIdAndTrialViewCodeResponse
{
    public data: { [index:string]: string; } = {};
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetITileDataByInstitutionIdAndTrialViewCodeResponse>) { (Object as any).assign(this, init); }
}

export class GetITileInformationDataByInstitutionIdAndTrialIdResponse
{
    public data: { [index:string]: ITileInformationData; } = {};
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetITileInformationDataByInstitutionIdAndTrialIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public refreshTokenExpiry?: string;

    // @DataMember(Order=9)
    public profileUrl: string;

    // @DataMember(Order=10)
    public roles: string[];

    // @DataMember(Order=11)
    public permissions: string[];

    // @DataMember(Order=12)
    public authProvider: string;

    // @DataMember(Order=13)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=14)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index:string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index:string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetApiKeysResponse
{
    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegenerateApiKeysResponse
{
    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RegenerateApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @Route("/font-awesome/{PathInfo*}")
export class GetFontJavaScript
{
    public pathInfo: string;

    public constructor(init?: Partial<GetFontJavaScript>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFontJavaScript'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

export class GetClientAppSettings implements IReturn<GetClientAppSettingsResponse>
{

    public constructor(init?: Partial<GetClientAppSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClientAppSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetClientAppSettingsResponse(); }
}

export class GetFavourites implements IReturn<GetFavouritesResponse>
{

    public constructor(init?: Partial<GetFavourites>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFavourites'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetFavouritesResponse(); }
}

export class SetFavourite implements IReturn<SetFavouriteResponse>
{
    public trialId: number;

    public constructor(init?: Partial<SetFavourite>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetFavourite'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetFavouriteResponse(); }
}

export class SetItemStates implements IReturn<SetItemStatesResponse>
{
    public trialId: number;
    public expandMenuItemId: number;

    public constructor(init?: Partial<SetItemStates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetItemStates'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetItemStatesResponse(); }
}

export class GetStaticTypes
{
    public tileInformationDataList: TileInformationDataList;

    public constructor(init?: Partial<GetStaticTypes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetStaticTypes'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

export class GetInstitutionsByUser implements IReturn<GetInstitutionsByUserResponse>
{

    public constructor(init?: Partial<GetInstitutionsByUser>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionsByUser'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionsByUserResponse(); }
}

export class GetTrialsByUserAndInstitutionId implements IReturn<GetTrialsByUserAndInstitutionIdResponse>
{
    public institutionId?: number;

    public constructor(init?: Partial<GetTrialsByUserAndInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialsByUserAndInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialsByUserAndInstitutionIdResponse(); }
}

export class GetSidebarByUser implements IReturn<GetSidebarByUserResponse>
{

    public constructor(init?: Partial<GetSidebarByUser>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSidebarByUser'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSidebarByUserResponse(); }
}

export class GetHeaderMenuByUser implements IReturn<GetHeaderMenuByUserResponse>
{

    public constructor(init?: Partial<GetHeaderMenuByUser>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetHeaderMenuByUser'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetHeaderMenuByUserResponse(); }
}

export class GetTrialsMenuItems implements IReturn<GetTrialsMenuItemsResponse>
{
    public trialId?: number;
    public institutionId: string;

    public constructor(init?: Partial<GetTrialsMenuItems>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialsMenuItems'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTrialsMenuItemsResponse(); }
}

export class GetITileDataByInstitutionIdAndTrialViewCode implements IReturn<GetITileDataByInstitutionIdAndTrialViewCodeResponse>
{
    public trialId?: number;
    public institutionId: string;
    public apiLinksUnconfigured: string[] = [];

    public constructor(init?: Partial<GetITileDataByInstitutionIdAndTrialViewCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetITileDataByInstitutionIdAndTrialViewCode'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetITileDataByInstitutionIdAndTrialViewCodeResponse(); }
}

export class GetITileInformationDataByInstitutionIdAndTrialId implements IReturn<GetITileInformationDataByInstitutionIdAndTrialIdResponse>
{
    public trialId?: number;
    public institutionId: string;
    public apiLinksUnconfigured: string[] = [];

    public constructor(init?: Partial<GetITileInformationDataByInstitutionIdAndTrialId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetITileInformationDataByInstitutionIdAndTrialId'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetITileInformationDataByInstitutionIdAndTrialIdResponse(); }
}

/** @description Sign In */
// @Route("/auth", "GET,POST")
// @Route("/auth/{provider}", "GET,POST")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public userName: string;

    // @DataMember(Order=3)
    public password: string;

    // @DataMember(Order=4)
    public rememberMe?: boolean;

    // @DataMember(Order=5)
    public accessToken: string;

    // @DataMember(Order=6)
    public accessTokenSecret: string;

    // @DataMember(Order=7)
    public returnUrl: string;

    // @DataMember(Order=8)
    public errorView: string;

    // @DataMember(Order=9)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}

// @Route("/assignroles", "POST")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignRolesResponse(); }
}

// @Route("/unassignroles", "POST")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnAssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UnAssignRolesResponse(); }
}

// @Route("/apikeys")
// @Route("/apikeys/{Environment}")
// @DataContract
export class GetApiKeys implements IReturn<GetApiKeysResponse>, IGet
{
    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<GetApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetApiKeys'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetApiKeysResponse(); }
}

// @Route("/apikeys/regenerate")
// @Route("/apikeys/regenerate/{Environment}")
// @DataContract
export class RegenerateApiKeys implements IReturn<RegenerateApiKeysResponse>, IPost
{
    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index:string]: string; };

    public constructor(init?: Partial<RegenerateApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegenerateApiKeys'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegenerateApiKeysResponse(); }
}

